import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ContentProvider } from "@/hooks/useContent";
import { StorePickerProvider } from "@/hooks/useStorePicker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContentProvider>
      <StorePickerProvider>
        <App />
      </StorePickerProvider>
    </ContentProvider>
  </React.StrictMode>,
);